// DEPLOY: /var/www/woody.wtf/frontend/src/chart/MyAlerts.js
// Every alert line the user has, across all tickers (/api/alerts/lines), with its status and
// note. Choosing one opens that ticker. Desktop: dialog. Phone: slide-up sheet.
import React, { useEffect, useState } from 'react';
import api from '../api';

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '10vh' },
  box:     { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'calc(var(--radius) * 2)', boxShadow: '0 8px 32px rgba(0,0,0,0.2)', width: '520px', maxWidth: '94vw', maxHeight: '70vh', display: 'flex', flexDirection: 'column' },
  sheet:   { position: 'fixed', left: 0, right: 0, bottom: 0, maxHeight: '75vh', background: 'var(--surface)', borderRadius: '14px 14px 0 0', display: 'flex', flexDirection: 'column', zIndex: 1001 },
  head:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid var(--border)' },
  title:   { fontSize: '14px', fontWeight: 700 },
  close:   { border: 'none', background: 'none', fontSize: '16px', color: 'var(--text-muted)', cursor: 'pointer' },
  list:    { overflowY: 'auto', padding: '4px 8px 12px' },
  item:    { display: 'grid', gridTemplateColumns: '90px 1fr auto', gap: '10px', alignItems: 'baseline', width: '100%', padding: '9px 6px', border: 'none', borderBottom: '1px solid var(--border)', background: 'none', cursor: 'pointer', textAlign: 'left', color: 'var(--text)', fontSize: '13px' },
  ticker:  { fontFamily: "'JetBrains Mono',monospace", fontWeight: 600 },
  note:    { color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  badge:   { fontSize: '10px', fontFamily: "'JetBrains Mono',monospace", fontWeight: 700, padding: '2px 6px', borderRadius: '4px', textTransform: 'uppercase' },
  empty:   { padding: '24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '13px' },
};
const BADGE = {
  new: ['var(--accent-dim)', 'var(--accent)'], armed: ['var(--success-dim)', 'var(--success)'], fired: ['var(--warning-dim)', 'var(--warning)'],
  expired: ['var(--surface-2)', 'var(--text-muted)'], error: ['var(--error-dim)', 'var(--error)'], off: ['var(--surface-2)', 'var(--text-muted)'],
};

export default function MyAlerts({ mobile, onOpen, onClose }) {
  const [lines, setLines] = useState(null);
  useEffect(() => { api.get('/alerts/lines').then(r => setLines(r.data.lines || [])).catch(() => setLines([])); }, []);
  const body = (
    <div style={mobile ? S.sheet : S.box} onPointerDown={e => e.stopPropagation()}>
      <div style={S.head}><span style={S.title}>🔔 My alert lines</span><button style={S.close} onClick={onClose}>✕</button></div>
      <div style={S.list}>
        {lines === null && <div style={S.empty}>Loading…</div>}
        {lines?.length === 0 && <div style={S.empty}>No alert lines yet. Draw one with Alerts → Alert line.</div>}
        {lines?.map(l => {
          const st = l.alert.armed === false ? 'off' : l.state.status;
          const [bg, fg] = BADGE[st] || BADGE.new;
          return (
            <button key={l.id} style={S.item} onClick={() => onOpen(l.ticker)}>
              <span style={S.ticker}>{l.ticker}</span>
              <span style={S.note}>{l.alert.dir === 'below' ? '▼ below' : '▲ above'}{l.alert.note ? ` · ${l.alert.note.split('\n')[0]}` : ''}
                {l.state.last_fired_d ? ` · fired ${l.state.last_fired_d}` : ''}</span>
              <span style={{ ...S.badge, background: bg, color: fg }}>{st}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
  return (
    <div style={mobile ? { position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 1000 } : S.overlay}
         onPointerDown={e => { if (e.target === e.currentTarget) onClose(); }}>{body}</div>
  );
}
